import { type DisclosureLink } from '../../components'

export const getHYCSDisclosures = (disclosures: Record<string, string>) => {
  const egwaLinks: DisclosureLink[] = [
    {
      text: 'Investment Advisory Agreement',
      url: disclosures.investmentAdvisoryAgreement,
    },
    {
      text: 'ADV Part 2A & 2B',
      url: disclosures.advPart2A2b,
    },
    {
      text: 'Customer Relationship Summary',
      url: disclosures.customerRelationshipAgreement,
    },
    {
      text: 'Privacy Notice',
      url: disclosures.privacyPolicyAdvisors,
    },
  ]

  const csa: DisclosureLink[] = [
    {
      text: 'Deposit Agreement',
      url: disclosures.depositAgreement,
    },
    {
      text: 'Privacy Notice',
      url: disclosures.privacyPolicySection,
    },
    {
      text: 'Tax Certification for US Persons',
      url: disclosures.taxCertification,
    },
  ]

  return [
    {
      title: 'Evergreen Wealth Advisors',
      helper: 'I have read and agree to the Evergreen Wealth Advisors’ agreements below.',
      expanded: '',
      links: egwaLinks,
      name: 'egwa',
    },
    {
      title: 'Checking and Savings Account',
      helper: 'I have read and agree to the Evergreen Checking and Savings Account agreements below.',
      expanded: '',
      links: csa,
      name: 'csa',
    },
  ]
}
